import { useEffect } from "react";

import { useWellCardPanelStore } from "stores/wellCardPanel";

import { useChartSettings } from "components/multiphase-chart/context";

/**
 * Hands the preset the card's chart is on to the panel store, which seeds the
 * next chart the card mounts with it. Left in place on unmount: outliving the
 * chart is the point.
 */
export function usePublishChartPreset(): void {
  const [{ storedPreset }] = useChartSettings();
  const setChartPreset = useWellCardPanelStore((s) => s.setChartPreset);

  useEffect(() => setChartPreset(storedPreset), [storedPreset, setChartPreset]);
}
